import React from 'react'

const ErrorBar = ({errors}) => (
  <div className="error-bar">
    <div className="error-bar-icon">
      <div className="error-bar-triangle-icon error-icon"></div>
    </div>
    <div>
      {errors.map((error, i) => (
        <div className="error" key={i} dangerouslySetInnerHTML={{__html: error}} />
      ))}
    </div>
  </div>
)

export default ErrorBar
